var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export var mutations = {
    setJobLists: function (state, lists) {
        state.jobLists = lists;
    },
    appendJobList: function (state, list) {
        var index = state.jobLists.findIndex(function (item) { return item.id === list.id; });
        if (index >= 0) {
            state.jobLists[index] = list;
        }
        else {
            state.jobLists.push(list);
        }
    },
    setLoading: function (state, loading) {
        state.loading = loading;
    },
    setJobListCreateApiError: function (state, jobListCreateApiError) {
        state.jobListCreateApiError = jobListCreateApiError;
    },
    setJobListUpdateApiError: function (state, jobListUpdateApiError) {
        state.jobListUpdateApiError = jobListUpdateApiError;
    },
    updateJobList: function (state, jobList) {
        var jobListIndex = state.jobLists.findIndex(function (iteratedJobList) { return iteratedJobList.id === jobList.id; });
        state.jobLists[jobListIndex] = jobList;
        state.jobLists = __spreadArray([], state.jobLists);
    },
    setJobListSharingSettings: function (state, sharingSettings) {
        state.jobListSharingSettings = sharingSettings;
    },
};
export var types = {
    SET_JOB_LISTS: 'setJobLists',
    APPEND_JOB_LIST: 'appendJobList',
    SET_LOADING: 'setLoading',
    UPDATE_JOB_LIST: 'updateJobList',
    JOB_LIST_CREATE_API_ERROR: 'setJobListCreateApiError',
    JOB_LIST_UPDATE_API_ERROR: 'setJobListUpdateApiError',
    SET_SHARING_SETTINGS: 'setJobListSharingSettings',
};
